/**
 * Predefined team templates for DexBuilder
 * All pokemon include complete movesets, items, abilities, and natures
 */
export const TEAM_TEMPLATES = {
  competitive: {
    name: { en: 'Competitive OU', es: 'Competitivo OU' },
    description: { en: 'Standard OU team with balanced coverage', es: 'Equipo OU estándar con cobertura balanceada' },
    pokemon: [
      {
        id: 149, name: 'dragonite', level: 50, nature: 'adamant',
        ability: 'multiscale', item: 'life-orb',
        moves: ['dragon-dance', 'outrage', 'extreme-speed', 'earthquake'],
        evs: { hp: 4, atk: 252, def: 0, spa: 0, spd: 0, spe: 252 },
        ivs: { hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 31 }
      },
      {
        id: 94, name: 'gengar', level: 50, nature: 'timid',
        ability: 'levitate', item: 'life-orb',
        moves: ['sludge-bomb', 'focus-blast', 'shadow-ball', 'dark-pulse'],
        evs: { hp: 0, atk: 0, def: 0, spa: 252, spd: 4, spe: 252 },
        ivs: { hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 31 }
      },
      {
        id: 130, name: 'gyarados', level: 50, nature: 'jolly',
        ability: 'intimidate', item: 'choice-scarf',
        moves: ['waterfall', 'earthquake', 'stone-edge', 'power-whip'],
        evs: { hp: 0, atk: 252, def: 0, spa: 0, spd: 4, spe: 252 },
        ivs: { hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 31 }
      },
      {
        id: 445, name: 'garchomp', level: 50, nature: 'jolly',
        ability: 'rough-skin', item: 'choice-scarf',
        moves: ['earthquake', 'outrage', 'stone-edge', 'u-turn'],
        evs: { hp: 0, atk: 252, def: 0, spa: 0, spd: 4, spe: 252 },
        ivs: { hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 31 }
      },
      {
        id: 143, name: 'snorlax', level: 50, nature: 'careful',
        ability: 'thick-fat', item: 'assault-vest',
        moves: ['earthquake', 'crunch', 'rest', 'curse'],
        evs: { hp: 252, atk: 0, def: 0, spa: 0, spd: 252, spe: 4 },
        ivs: { hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 31 }
      },
      {
        id: 282, name: 'gardevoir', level: 50, nature: 'modest',
        ability: 'trace', item: 'choice-specs',
        moves: ['psychic', 'dazzling-gleam', 'focus-blast', 'shadow-ball'],
        evs: { hp: 0, atk: 0, def: 0, spa: 252, spd: 4, spe: 252 },
        ivs: { hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 31 }
      }
    ]
  },
  casual: {
    name: { en: 'Casual Adventure', es: 'Aventura Casual' },
    description: { en: 'Fun team for story playthrough', es: 'Equipo divertido para la historia' },
    pokemon: [
      {
        id: 25, name: 'pikachu', level: 50, nature: 'jolly',
        ability: 'static', item: 'light-ball',
        moves: ['thunderbolt', 'quick-attack', 'irontail', 'thunder-wave'],
        evs: { hp: 4, atk: 0, def: 0, spa: 252, spd: 0, spe: 252 },
        ivs: { hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 31 }
      },
      {
        id: 6, name: 'charizard', level: 50, nature: 'timid',
        ability: 'blaze', item: 'charcoal',
        moves: ['flamethrower', 'air-slash', 'earthquake', 'roost'],
        evs: { hp: 0, atk: 0, def: 0, spa: 252, spd: 4, spe: 252 },
        ivs: { hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 31 }
      },
      {
        id: 131, name: 'lapras', level: 50, nature: 'modest',
        ability: 'water-absorb', item: 'assault-vest',
        moves: ['hydro-pump', 'ice-beam', 'thunderbolt', 'ancient-power'],
        evs: { hp: 252, atk: 0, def: 0, spa: 252, spd: 0, spe: 4 },
        ivs: { hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 31 }
      },
      {
        id: 143, name: 'snorlax', level: 50, nature: 'adamant',
        ability: 'thick-fat', item: 'leftovers',
        moves: ['return', 'earthquake', 'crunch', 'rest'],
        evs: { hp: 252, atk: 252, def: 0, spa: 0, spd: 4, spe: 0 },
        ivs: { hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 31 }
      },
      {
        id: 65, name: 'alakazam', level: 50, nature: 'timid',
        ability: 'magic-guard', item: 'life-orb',
        moves: ['psychic', 'focus-blast', 'shadow-ball', 'hidden-power'],
        evs: { hp: 0, atk: 0, def: 0, spa: 252, spd: 4, spe: 252 },
        ivs: { hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 31 }
      },
      {
        id: 68, name: 'machamp', level: 50, nature: 'adamant',
        ability: 'no-guard', item: 'choice-band',
        moves: ['dynamic-punch', 'stone-edge', 'ice-punch', 'bullet-punch'],
        evs: { hp: 0, atk: 252, def: 0, spa: 0, spd: 4, spe: 252 },
        ivs: { hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 31 }
      }
    ]
  },
  starters: {
    name: { en: 'Starter Squad', es: 'Escuadrón Inicial' },
    description: { en: 'Classic starter Pokemon team', es: 'Equipo clásico de iniciales' },
    pokemon: [
      {
        id: 3, name: 'venusaur', level: 50, nature: 'modest',
        ability: 'chlorophyll', item: 'assault-vest',
        moves: ['sludge-bomb', 'giga-drain', 'focus-blast', 'hidden-power'],
        evs: { hp: 0, atk: 0, def: 0, spa: 252, spd: 4, spe: 252 },
        ivs: { hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 31 }
      },
      {
        id: 6, name: 'charizard', level: 50, nature: 'timid',
        ability: 'blaze', item: 'life-orb',
        moves: ['flamethrower', 'air-slash', 'dragon-pulse', 'roost'],
        evs: { hp: 0, atk: 0, def: 0, spa: 252, spd: 4, spe: 252 },
        ivs: { hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 31 }
      },
      {
        id: 9, name: 'blastoise', level: 50, nature: 'modest',
        ability: 'torrent', item: 'choice-specs',
        moves: ['hydro-pump', 'ice-beam', 'focus-blast', 'dark-pulse'],
        evs: { hp: 0, atk: 0, def: 0, spa: 252, spd: 4, spe: 252 },
        ivs: { hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 31 }
      },
      {
        id: 154, name: 'meganium', level: 50, nature: 'calm',
        ability: 'overgrow', item: 'assault-vest',
        moves: ['giga-drain', 'sludge-bomb', 'synthesis', 'light-screen'],
        evs: { hp: 252, atk: 0, def: 4, spa: 0, spd: 252, spe: 0 },
        ivs: { hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 31 }
      },
      {
        id: 157, name: 'typhlosion', level: 50, nature: 'timid',
        ability: 'blaze', item: 'life-orb',
        moves: ['flamethrower', 'focus-blast', 'hidden-power', 'earthquake'],
        evs: { hp: 0, atk: 0, def: 0, spa: 252, spd: 4, spe: 252 },
        ivs: { hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 31 }
      },
      {
        id: 160, name: 'feraligatr', level: 50, nature: 'adamant',
        ability: 'torrent', item: 'choice-band',
        moves: ['waterfall', 'earthquake', 'stone-edge', 'ice-punch'],
        evs: { hp: 0, atk: 252, def: 0, spa: 0, spd: 4, spe: 252 },
        ivs: { hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 31 }
      }
    ]
  },
  yukiVGC: {
    name: { en: 'Yuki Hyper Offensive VGC', es: 'Yuki Hiper Ofensivo VGC' },
    description: { en: 'Hyper offensive VGC 2026 Regi with Mega Lucario & Mega Gardevoir', es: 'Equipo VGC 2026 hiper ofensivo con Mega Lucario y Mega Gardevoir' },
    pokemon: [
      {
        id: 663, name: 'talonflame', level: 50, nature: 'jolly',
        ability: 'gale-wings', item: 'sharp-beak',
        teraType: 'fire',
        moves: ['dual-wingbeat', 'flare-blitz', 'tailwind', 'quick-guard'],
        evs: { hp: 4, atk: 252, def: 0, spa: 0, spd: 0, spe: 252 },
        ivs: { hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 31 }
      },
      {
        id: 908, name: 'meowscarada', level: 50, nature: 'jolly',
        ability: 'overgrow', item: 'focus-sash',
        teraType: 'grass',
        moves: ['flower-trick', 'knock-off', 'sucker-punch', 'protect'],
        evs: { hp: 4, atk: 252, def: 0, spa: 0, spd: 0, spe: 252 },
        ivs: { hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 31 }
      },
      {
        id: 350, name: 'milotic', level: 50, nature: 'modest',
        ability: 'competitive', item: 'leftovers',
        teraType: 'water',
        moves: ['helping-hand', 'scald', 'recover', 'protect'],
        evs: { hp: 252, atk: 0, def: 0, spa: 252, spd: 4, spe: 0 },
        ivs: { hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 31 }
      },
      {
        id: 448, name: 'lucario', level: 50, nature: 'adamant',
        ability: 'inner-focus', item: 'lucarionite',
        teraType: 'fighting',
        moves: ['close-combat', 'meteor-mash', 'bullet-punch', 'protect'],
        evs: { hp: 4, atk: 252, def: 0, spa: 0, spd: 0, spe: 252 },
        ivs: { hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 31 }
      },
      {
        id: 445, name: 'garchomp', level: 50, nature: 'jolly',
        ability: 'rough-skin', item: 'soft-sand',
        teraType: 'dragon',
        moves: ['earthquake', 'dragon-claw', 'rock-slide', 'protect'],
        evs: { hp: 4, atk: 252, def: 0, spa: 0, spd: 0, spe: 252 },
        ivs: { hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 31 }
      },
      {
        id: 282, name: 'gardevoir', level: 50, nature: 'modest',
        ability: 'telepathy', item: 'gardevoirite',
        teraType: 'psychic',
        moves: ['dazzling-gleam', 'psychic', 'trick-room', 'protect'],
        evs: { hp: 252, atk: 0, def: 0, spa: 252, spd: 4, spe: 0 },
        ivs: { hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 31 }
      }
    ]
  },
  sunnyTR: {
    name: { en: 'Sunny Trick Room', es: 'Sala Trampa Solar' },
    description: { en: 'VGC Sun + Trick Room team with Mega Charizard Y', es: 'Equipo VGC Sol + Sala Trampa con Mega Charizard Y' },
    pokemon: [
      {
        id: 727, name: 'incineroar', level: 50, nature: 'brave',
        ability: 'intimidate', item: 'shuca-berry',
        teraType: 'fire',
        moves: ['flare-blitz', 'darkest-lariat', 'close-combat', 'fake-out'],
        evs: { hp: 252, atk: 196, def: 4, spa: 0, spd: 60, spe: 0 },
        ivs: { hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 0 }
      },
      {
        id: 858, name: 'hatterene', level: 50, nature: 'quiet',
        ability: 'magic-bounce', item: 'fairy-feather',
        teraType: 'psychic',
        shiny: true,
        moves: ['psychic', 'trick-room', 'magic-powder', 'dazzling-gleam'],
        evs: { hp: 220, atk: 0, def: 36, spa: 252, spd: 4, spe: 0 },
        ivs: { hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 0 }
      },
      {
        id: 981, name: 'farigiraf', level: 50, nature: 'modest',
        ability: 'armor-tail', item: 'sitrus-berry',
        teraType: 'normal',
        moves: ['hyper-voice', 'trick-room', 'imprison', 'protect'],
        evs: { hp: 228, atk: 0, def: 76, spa: 84, spd: 128, spe: 0 },
        ivs: { hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 0 }
      },
      {
        id: 324, name: 'torkoal', level: 50, nature: 'quiet',
        ability: 'drought', item: 'charcoal',
        teraType: 'fire',
        shiny: true,
        moves: ['eruption', 'weather-ball', 'earth-power', 'protect'],
        evs: { hp: 252, atk: 0, def: 4, spa: 252, spd: 4, spe: 0 },
        ivs: { hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 0 }
      },
      {
        id: 983, name: 'kingambit', level: 50, nature: 'brave',
        ability: 'defiant', item: 'black-glasses',
        teraType: 'dark',
        moves: ['kowtow-cleave', 'sucker-punch', 'iron-head', 'swords-dance'],
        evs: { hp: 252, atk: 212, def: 0, spa: 0, spd: 52, spe: 0 },
        ivs: { hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 0 }
      },
      {
        id: 6, name: 'charizard', level: 50, nature: 'timid',
        ability: 'solar-power', item: 'charizardite-y',
        teraType: 'fire',
        moves: ['heat-wave', 'weather-ball', 'solar-beam', 'protect'],
        evs: { hp: 12, atk: 0, def: 252, spa: 0, spd: 0, spe: 252 },
        ivs: { hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 31 }
      }
    ]
  },
  legends: {
    name: { en: 'Legendary Trio', es: 'Trío Legendario' },
    description: { en: 'Powerful legendary Pokemon', es: 'Pokémon legendarios poderosos' },
    pokemon: [
      {
        id: 150, name: 'mewtwo', level: 100, nature: 'timid',
        ability: 'pressure', item: 'life-orb',
        moves: ['psychic', 'aura-sphere', 'flamethrower', 'ice-beam'],
        evs: { hp: 4, atk: 0, def: 0, spa: 252, spd: 0, spe: 252 },
        ivs: { hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 31 }
      },
      {
        id: 249, name: 'lugia', level: 100, nature: 'bold',
        ability: 'multiscale', item: 'assault-vest',
        moves: ['roost', 'toxic', 'recover', 'brave-bird'],
        evs: { hp: 252, atk: 0, def: 252, spa: 0, spd: 4, spe: 0 },
        ivs: { hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 31 }
      },
      {
        id: 250, name: 'ho-oh', level: 100, nature: 'adamant',
        ability: 'regenerator', item: 'assault-vest',
        moves: ['brave-bird', 'earthquake', 'stone-edge', 'recover'],
        evs: { hp: 252, atk: 252, def: 4, spa: 0, spd: 0, spe: 0 },
        ivs: { hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 31 }
      },
      {
        id: 384, name: 'rayquaza', level: 100, nature: 'jolly',
        ability: 'air-lock', item: 'life-orb',
        moves: ['dragon-dance', 'outrage', 'extreme-speed', 'earthquake'],
        evs: { hp: 0, atk: 252, def: 0, spa: 0, spd: 4, spe: 252 },
        ivs: { hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 31 }
      },
      {
        id: 483, name: 'dialga', level: 100, nature: 'modest',
        ability: 'pressure', item: 'life-orb',
        moves: ['flash-cannon', 'earth-power', 'aura-sphere', 'recover'],
        evs: { hp: 4, atk: 0, def: 0, spa: 252, spd: 0, spe: 252 },
        ivs: { hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 31 }
      },
      {
        id: 484, name: 'palkia', level: 100, nature: 'timid',
        ability: 'pressure', item: 'choice-specs',
        moves: ['spacial-rend', 'hydro-pump', 'aura-sphere', 'recover'],
        evs: { hp: 0, atk: 0, def: 0, spa: 252, spd: 4, spe: 252 },
        ivs: { hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 31 }
      }
    ]
  }
};
